import * as ZapparThree from "@zappar/zappar-threejs";
import { PCFSoftShadowMap, sRGBEncoding, WebGLRenderer } from "three";

export function initRenderer() {
  const width = window.innerWidth + (window.innerWidth % 2),
    height = window.innerHeight + (window.innerHeight % 2);

  let renderer = new WebGLRenderer({ alpha: true, preserveDrawingBuffer: true });

  renderer.outputEncoding = sRGBEncoding;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = PCFSoftShadowMap;
  renderer.physicallyCorrectLights = true;
  renderer.setPixelRatio(window.devicePixelRatio);
  renderer.setSize(width, height);
  document.body.appendChild(renderer.domElement);
  // The Zappar library needs the WebGL context to process camera images
  // Use this function to set your context
  ZapparThree.glContextSet(renderer.getContext());
  window.addEventListener("resize", () => {
    renderer.setPixelRatio(window.devicePixelRatio);
    renderer.setSize(window.innerWidth, window.innerHeight);
  });
  return renderer;
}
